import React from "react";
import Post from "./Post/Post";
import style from "./Posts.module.css";

const Posts = (props) => {
    let postElement = props.posts.map(post => <Post key={post.id} name={post.name}
            imgURL={post.imgURL} video={post.video} published={post.published} message={post.message} likeCount={post.likeCount} imgRandom={post.imgRandom}/>);
    let newPostElement = React.createRef();
    let onAddPost = () => {
        props.addPost();
    }
    let onPostChange = (e) => {
        let text = e.target.value;
        props.updateNewPostText(text);
    }

    return (
        <div className={style.myPostsContainer}>
            <div className={style.newPostBox}>
                <h5 className={style.myPostsHeader}>My recent posts</h5><hr></hr>
                <textarea onChange={onPostChange} rows="2" value={props.newPostText} ref={newPostElement}></textarea>
                
                <button className={style.myProfilePostBtn} onClick={onAddPost}>Post</button>
            </div>
            {postElement}
        </div>
    )
}
export default Posts;